import { titlepiece as titlepieceAsObj, headline as headlineAsObj, body as bodyAsObj, textSans as textSansAsObj, } from './api';
import { objectStylesToString } from './object-styles-to-string';
import { titlepieceSizes, headlineSizes, bodySizes, textSansSizes, remTitlepieceSizes, remHeadlineSizes, remBodySizes, remTextSansSizes, fontMapping, fontWeightMapping, lineHeightMapping, } from './data';
const fromEntries = (entries) => entries.reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
}, {});
const titlepiece = fromEntries(Object.entries(titlepieceAsObj).map(([key, func]) => {
    return [
        key,
        (options) => objectStylesToString(func(options)),
    ];
}));
const headline = fromEntries(Object.entries(headlineAsObj).map(([key, func]) => {
    return [
        key,
        (options) => objectStylesToString(func(options)),
    ];
}));
const body = fromEntries(Object.entries(bodyAsObj).map(([key, func]) => {
    return [
        key,
        (options) => objectStylesToString(func(options)),
    ];
}));
const textSans = fromEntries(Object.entries(textSansAsObj).map(([key, func]) => {
    return [
        key,
        (options) => objectStylesToString(func(options)),
    ];
}));
export { titlepiece, headline, body, textSans, titlepieceSizes, headlineSizes, bodySizes, textSansSizes, remTitlepieceSizes, remHeadlineSizes, remBodySizes, remTextSansSizes, fontMapping as fonts, fontWeightMapping as fontWeights, lineHeightMapping as lineHeights, };
//# sourceMappingURL=index.js.map
